import apiService from './apiService';

/**
 * Ecommerce Store & Warehouse Location Service
 * Fetches physical store and warehouse locations from the public /api/ecommerce/store-locations endpoint
 */
class StoreLocationService {
    /**
     * Fetch active store and warehouse locations configured by admin for the storefront.
     * Expected endpoint: GET /api/ecommerce/store-locations
     *
     * Response shape:
     *   {
     *     success: true,
     *     data: {
     *       storeLocations: [
     *         {
     *           _id: "...",
     *           name: "...",
     *           type: "store", // "store" | "warehouse" | "store_warehouse"
     *           address: "...",
     *           area: "...",
     *           city: "...",
     *           contact_number: "...",
     *           google_maps_url: "...",
     *           opening_hours: "...",
     *           description: "...",
     *           display_order: 1,
     *           is_active: true
     *         }
     *       ]
     *     }
     *   }
     *
     * Also supports alternative backend response keys gracefully:
     *   - data.locations
     *   - data.stores
     *   - data.warehouses
     *   - data (array)
     *   - response (array)
     *
     * @param {object} params - Optional query parameters (e.g. { active_only: true })
     * @returns {Promise<Array>} Array of raw location objects
     */
    async getAll(params = {}) {
        try {
            const response = await apiService.get('/ecommerce/store-locations', params);

            // Flexibly extract array across various standard response envelopes
            const candidates = [
                response?.data?.storeLocations,
                response?.data?.locations,
                response?.data?.stores,
                response?.data?.warehouses,
                response?.storeLocations,
                response?.locations,
                response?.stores,
                Array.isArray(response?.data) ? response.data : null,
                Array.isArray(response) ? response : null,
            ];

            const list = candidates.find((arr) => Array.isArray(arr));
            return list || [];
        } catch (error) {
            console.warn(
                '[StoreLocationService] Failed to load locations from API:',
                error?.message || error
            );
            throw error;
        }
    }
}

const storeLocationService = new StoreLocationService();
export default storeLocationService;
